var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 0.666992C0.6 0.666992 0 1.26699 0 2.00033C0 2.73366 0.6 3.33366 1.33333 3.33366C2.06667 3.33366 2.66667 2.73366 2.66667 2.00033C2.66667 1.26699 2.06667 0.666992 1.33333 0.666992ZM10.6667 0.666992C9.93333 0.666992 9.33333 1.26699 9.33333 2.00033C9.33333 2.73366 9.93333 3.33366 10.6667 3.33366C11.4 3.33366 12 2.73366 12 2.00033C12 1.26699 11.4 0.666992 10.6667 0.666992ZM6 0.666992C5.26667 0.666992 4.66667 1.26699 4.66667 2.00033C4.66667 2.73366 5.26667 3.33366 6 3.33366C6.73333 3.33366 7.33333 2.73366 7.33333 2.00033C7.33333 1.26699 6.73333 0.666992 6 0.666992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.95f1d2b76a94870e9fac16cf19c3ad17.svg";
export { ForwardRef as ReactComponent };